module.exports = __webpack_public_path__ + "img/73_03.4b1ddcad.png";